module.exports = __webpack_public_path__ + "img/carousel-vet-6.d74a5141.jpg";